import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/*',
    name: 'page-maintain',
    component: () => import('../views/home/maintain.vue'),
    meta: {
      isHiddenMenu: true,
    },
  },
  {
    path: '/',
    name: 'page-home',
    component: () => import('../views/home'),
    meta: {
      title: 'home',
    },
  },
  {
    path: '/about',
    name: 'page-about',
    component: () => import('../views/about'),
    meta: {
      title: 'about',
    },
    children: [
      {
        path: 'member/:id',
        name: 'page-member-detail',
        component: () => import('../views/about/_member.vue'),
        props: true,
      },
    ],
  },
  {
    path: '/projects/:typeid?',
    name: 'page-project-list',
    component: () => import('../views/project'),
    meta: {
      title: 'project',
    },
  },
  {
    path: '/project/:id',
    name: 'page-project-detail',
    component: () => import('../views/project/detail.vue'),
    meta: {
      title: 'back',
    },
  },
  {
    path: '/contact',
    name: 'page-contact',
    component: () => import('../views/contact'),
    meta: {
      title: 'contact',
    },
  },
  {
    path: '/jobs',
    name: 'page-job-list',
    component: () => import('../views/job'),
    meta: {
      title: 'jobs',
    },
  },
  {
    path: '/news',
    name: 'page-news-list',
    component: () => import('../views/news'),
    meta: {
      title: 'news',
    },
  },
  {
    path: '/news/:id(\\d)',
    name: 'page-news-detail',
    component: () => import('../views/news/detail.vue'),
    meta: {
      title: 'news',
    },
  },
  {
    path: '/test',
    name: 'page-test',
    component: () => import('../views/about/test.vue'),
  },
];

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  store.commit('setForward', from.name);
  if (store.state.productCategory === null) {
    store.dispatch('getCategories').then(() => {
      next();
    });
  } else {
    next();
  }
});

export default router;
